import type { VideoPlayerControlTypesT } from '../../labelling/types';
import { FRAME_STEP_SIZE, VIDEO_PLAYER_CONTROL_TYPES } from '../components/frames-control-panel/constants';
type ExecutePlaybackActionParams = {
  controlType: VideoPlayerControlTypesT;
  currentFrame: number;
  maxFrames: number;
  onFrameChange: (frame: number) => void;
  startPlaying: () => void;
};
export function executePlaybackAction({
  controlType,
  currentFrame,
  maxFrames,
  onFrameChange,
  startPlaying
}: ExecutePlaybackActionParams) {
  switch (controlType) {
    case VIDEO_PLAYER_CONTROL_TYPES.SKIP_TO_FIRST:
      currentFrame !== 0 && onFrameChange(0);
      break;
    case VIDEO_PLAYER_CONTROL_TYPES.BACKWARD:
      currentFrame > 0 && onFrameChange(currentFrame - FRAME_STEP_SIZE.DEFAULT);
      break;
    case VIDEO_PLAYER_CONTROL_TYPES.FORWARD:
      currentFrame < maxFrames - FRAME_STEP_SIZE.DEFAULT && onFrameChange(currentFrame + FRAME_STEP_SIZE.DEFAULT);
      break;
    case VIDEO_PLAYER_CONTROL_TYPES.SKIP_TO_LAST:
      currentFrame !== maxFrames - 1 && onFrameChange(maxFrames - 1);
      break;
    case VIDEO_PLAYER_CONTROL_TYPES.PLAY:
      currentFrame === maxFrames - 1 && onFrameChange(0);
      startPlaying();
      break;
    case VIDEO_PLAYER_CONTROL_TYPES.JUMP_FORWARD:
      {
        if (currentFrame === maxFrames - 1) break;
        const fwd = currentFrame === 0 ? FRAME_STEP_SIZE.TEN_FRAMES - 1 : FRAME_STEP_SIZE.TEN_FRAMES;
        onFrameChange(Math.min(maxFrames - 1, currentFrame + fwd));
        break;
      }
    case VIDEO_PLAYER_CONTROL_TYPES.JUMP_BACKWARD:
      {
        if (currentFrame === 0) break;
        const back = currentFrame === FRAME_STEP_SIZE.TEN_FRAMES - 1 ? FRAME_STEP_SIZE.TEN_FRAMES - 1 : FRAME_STEP_SIZE.TEN_FRAMES;
        onFrameChange(Math.max(0, currentFrame - back));
        break;
      }
    default:
      break;
  }
}